import TaxPage from './TaxPage';

export default TaxPage;
